<template>
  <div class="store__item clear">
    <div class="store__item__center">
      <div class="store__name">{{ store.shopName }}</div>
      <div class="store__desc">
        上架{{ store.onSaleGoodsNum }}种商品 满{{ price(store.minDeliveryAmount) }}元起送，满{{
          price(store.parcelAmount)
        }}包邮
      </div>
      <div class="store__tags">
        <span v-for="tag in store.shopTags" :key="tag" class="tag pointer">{{ tag }}</span>
      </div>
      <div v-if="store.validCoupons && store.validCoupons.length" class="store__coupon flex">
        <span class="store__coupon__title">券</span>
        <span v-for="coupon in store.validCoupons" :key="coupon.id" class="store__coupon__item pointer">
          {{ coupon.conditionRule }}
        </span>
      </div>
    </div>
    <div class="store__item__left">
      <img class="store__item__left__img" :src="store.shopIcon" alt="" />
    </div>
    <div class="store__item__right">
      <el-button @click="goStore" type="primary" size="mini" plain>
        <img style="width:14px;height:14px" class="vertical" src="@/assets/img/store-icon.png" />
        <span class="vertical">
          进入店铺
        </span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { priceFenToYuan } from '@/helpers/utils';
export default {
  props: {
    store: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    goStore() {
      this.$emit('go-store', this.store.shopId);
    },
    price(val) {
      return priceFenToYuan(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.store__item {
  min-height: 160px;
  background: #ffffff;
  box-shadow: 0px 1px 0px 0px #eeeeee;
  &__center,
  &__left,
  &__right {
    float: left;
  }
  &__center {
    padding: 16px 100px 16px 132px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .store__name {
      font-size: 24px;
      font-weight: 500;
      color: #262626;
      line-height: 1;
    }
    .store__desc {
      margin: 8px 0;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 1;
    }
    .store__tags {
      height: 20px;
      margin: 8px 0;
      .tag {
        display: inline-block;
        height: 20px;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: 400;
        color: #008dff;
        line-height: 1;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #008bf6;
        & + .tag {
          margin-left: 8px;
        }
      }
    }
    .store__coupon {
      width: 600px;
      min-height: 54px;
      padding: 12px;
      background: #f5f5f5;
      &__title {
        display: inline-block;
        width: 20px;
        height: 20px;
        padding: 4px;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 1;
        background: #fd5047;
        border-radius: 2px;
      }
      &__item {
        display: inline-block;
        height: 20px;
        margin-left: 4px;
        margin-bottom: 4px;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: 400;
        color: #ff3930;
        line-height: 1;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #ff3930;
      }
    }
  }
  &__left {
    width: 132px;
    font-size: 0;
    padding: 16px;
    margin-left: -100%;
    &__img {
      width: 100px;
      height: 100px;
    }
  }
  &__right {
    width: 100px;
    height: 166px;
    margin-left: -100px;
    &::before {
      display: inline-block;
      content: '';
      height: 100%;
      vertical-align: middle;
    }
  }
  & + .store__item {
    margin-top: 1px;
  }
  .vertical {
    vertical-align: middle;
  }
  .is-plain {
    color: #1e8dff !important;
    background: #ffffff;
  }
}
</style>
